import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { IconButton, WithTooltip } from 'basic-components';
import { Exit, History as HistoryIcon } from 'basic-components/icons';
import { StatusesEnums } from 'dashboard-services/api/statuses';
import TimeService from 'dashboard-services/services/TimeService';
import { StatusIcon } from 'primary-components';

import { statusesActions } from 'actions/modules/statuses';
import { statusesQueries } from 'queries/modules/statuses';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};

const Row = ({ componentStatuses = EMPTY_ARRAY, formula = undefined, jobId = undefined, name = undefined, payload = EMPTY_OBJ, startTime = undefined, status = undefined, type = undefined, warnStatuses = EMPTY_ARRAY }) => {
  const dispatch = useDispatch(),
        definedTime = useSelector(state => state.myAccountState.settingsState.definedTime),
        getNonETLId = useCallback((payload, componentStatuses) => statusesActions.getNonETLId(payload, componentStatuses), []),
        openItemRaw = statusesQueries.useOpenBasedOnStatusType({ formula, jobId, param: type === StatusesEnums.STATUS_TYPE.ETL ? (payload?.groupName || name) : getNonETLId(payload, componentStatuses), type }),
        openItem = useCallback(e => {
          e.preventDefault()
          e.stopPropagation()
          openItemRaw()
        }, [openItemRaw]),
        goToDetails = useCallback(() => dispatch(statusesActions.showDetails({ formula, jobId })), [dispatch, formula, jobId]),
        goToHistory = useCallback((e, name) => {
          e.preventDefault()
          e.stopPropagation()
          dispatch(statusesActions.showHistory({ formula, name, type }))
        }, [dispatch, formula, type]),
        // A formula row shows the formula as it was in that run, not the pipeline that ran it.
        displayName = formula ? formula.name : name,
        version = formula ? formula.version : payload?.version

  return (
    <div 
        className="statuses__main-view__content__block__body__item"
        onClick={goToDetails} 
    >
      <div className="statuses__main-view__content__block__body__item__status">
        <StatusIcon
            status={status}
            warnStatuses={warnStatuses}
        />
      </div>
      <div className="statuses__main-view__content__block__body__item__date">
        {String(TimeService.getUserFormattedDateTime(startTime, definedTime).split(" ")[0])}
      </div>
      <div className="statuses__main-view__content__block__body__item__time">
        {String(TimeService.getUserFormattedDateTime(startTime, definedTime).split(" ")[1])}
      </div>
      <div className="statuses__main-view__content__block__body__item__name">
        {displayName + (version ? " v." + version : "")}
      </div>
      <div className="statuses__main-view__content__block__body__item__icons">
        <WithTooltip
            data-place="top"
            short
            text="Last runs"
        >
          <IconButton
              className="statuses__main-view__content__block__body__item__icons__history"
              onClick={e => goToHistory(e, name)}
          >
            <HistoryIcon
                color="blue-bright"
                height={16}
                width={16}
            />
          </IconButton>
        </WithTooltip>
        <WithTooltip
            className="statuses__main-view__content__block__body__item__icons__exit"
            data-place="top"
            short
            text="Open"
        >
          <IconButton
              onClick={openItem}
          >
            <Exit
                color="blue-bright"
                height={16}
                width={16}
            />
          </IconButton>
        </WithTooltip>
      </div>
    </div>
  )
}

Row.propTypes = {
  componentStatuses: PropTypes.array, 
  formula: PropTypes.object,
  jobId: PropTypes.string, 
  name: PropTypes.string, 
  payload: PropTypes.object, 
  startTime: PropTypes.string, 
  status: PropTypes.string, 
  type: PropTypes.string, 
  warnStatuses: PropTypes.array
}

export default Row;